import { ContentType } from "../../../../enums/contentStack.js";
import pAll from "p-all";
import { getConfigurationSettingByDevelopmentKey } from "../../../../services/content/config.lib.js";
import { getFSAConfig } from "../../FSAEligibleInfo/lib.js";
import { getProductApiConfig, getProductDetailsServiceConfig, getProductDetailsV2ServiceConfig, getImageConfig, getPillBadgeConfig, getComingSoonFeatureToggleConfig, getStockStatusFeatureToggleConfig, getEnabledWarehousesConfig, getSearchConfig, getTranslations, getBOPIUpdatesSyncFeatureToggle, getEnabledWarehousesWIOConfig, getEnabledWarehousesBOPIWConfig, getFreightSavingsFeatureToggle, getPromoBreakdownFeatureToggle, getWarehousePriceOnlineFeatureToggleConfig, getProductSummaryAPIFeatureToggle, getBModPDPNavigationUrlFeatureToggleConfig, getShowMultiVariantsAvailabilityFeatureToggle, getInventoryApiConfig, getParsedProductDetailApiConfigParams, getParsedLucidWorksApiConfig, getTranslationsConfig, getParsedProductApiConfig, getParsedPillBadgeConfig, getParsedInventoryApiConfig, getParsedImageConfig, getParsedFeatureToggleConfig, getParsedEnabledWarehousesListConfig } from "./lib.js";
async function getProductTileConfigData(inventoryAware, locale) {
  var _a, _b, _c;
  const [
    productApiConfigEntry,
    productDetailApiConfigEntry,
    productDetailApiV2ConfigEntry,
    imageConfigEntry,
    pillBadgeConfigEntry,
    comingSoonFeatureToggleEntry,
    stockStatusFeatureToggleEntry,
    enabledWarehousesEntry,
    searchConfigEntry,
    translationsEntry,
    fsaConfigEntry,
    enableBOPIWUpdatesSyncEntry,
    enabledWarehousesWIOEntry,
    enabledWarehousesBOPIWEntry,
    enableFreightSavingsEntry,
    enablePromoBreakdownEntry,
    warehousePriceOnlineFeatureToggle,
    callProductSummaryAPI,
    enableBModPDPNavigationUrl,
    ShowMultiVariantsAvailabilityFeatureToggleEntry
  ] = await pAll(
    [
      () => getProductApiConfig(),
      () => getProductDetailsServiceConfig(),
      () => getProductDetailsV2ServiceConfig(),
      () => getImageConfig(),
      () => getPillBadgeConfig(),
      () => getComingSoonFeatureToggleConfig(),
      () => getStockStatusFeatureToggleConfig(),
      () => getEnabledWarehousesConfig(),
      () => getSearchConfig(),
      () => getTranslations(locale),
      () => getFSAConfig(locale),
      () => getBOPIUpdatesSyncFeatureToggle(),
      () => getEnabledWarehousesWIOConfig(),
      () => getEnabledWarehousesBOPIWConfig(),
      () => getFreightSavingsFeatureToggle(),
      () => getPromoBreakdownFeatureToggle(),
      () => getWarehousePriceOnlineFeatureToggleConfig(),
      () => getProductSummaryAPIFeatureToggle(),
      () => getBModPDPNavigationUrlFeatureToggleConfig(),
      () => getShowMultiVariantsAvailabilityFeatureToggle()
    ],
    { concurrency: 1 }
  );
  const inventoryApiConfigEntry = inventoryAware ? await getInventoryApiConfig() : null;
  const lucidWorksApiDevelopmentKey = (_b = (_a = translationsEntry == null ? void 0 : translationsEntry.properties) == null ? void 0 : _a[0]) == null ? void 0 : _b.lucidWorksApiDevelopmentKey;
  let lucidWorksApiConfigEntry = null;
  try {
    lucidWorksApiConfigEntry = lucidWorksApiDevelopmentKey ? await getConfigurationSettingByDevelopmentKey(
      ContentType.ServiceConfiguration,
      lucidWorksApiDevelopmentKey
    ) : null;
  } catch (err) {
    console.log(`Error loading lucid works api config entry: `, err);
  }
  const {
    enabledWarehouseListKey,
    productAPIClientId,
    imageProfileId,
    siteDomainKey,
    imageBasePathKey,
    productApiWarehouseNumber,
    pillBadgeLangKey
  } = ((_c = translationsEntry == null ? void 0 : translationsEntry.properties[0]) == null ? void 0 : _c.keys) || {};
  return {
    enabledWarehousesListConfig: getParsedEnabledWarehousesListConfig(
      enabledWarehousesEntry,
      enabledWarehousesWIOEntry,
      enabledWarehousesBOPIWEntry,
      enabledWarehouseListKey
    ),
    featureToggleConfig: getParsedFeatureToggleConfig(
      comingSoonFeatureToggleEntry,
      stockStatusFeatureToggleEntry,
      enableBOPIWUpdatesSyncEntry,
      enableFreightSavingsEntry,
      enablePromoBreakdownEntry,
      warehousePriceOnlineFeatureToggle,
      callProductSummaryAPI,
      enableBModPDPNavigationUrl,
      ShowMultiVariantsAvailabilityFeatureToggleEntry
    ),
    fsaConfig: fsaConfigEntry,
    imageConfig: getParsedImageConfig(
      imageConfigEntry,
      siteDomainKey,
      imageProfileId,
      imageBasePathKey
    ),
    inventoryApiConfig: getParsedInventoryApiConfig(
      inventoryApiConfigEntry
    ),
    pillBadgeConfig: getParsedPillBadgeConfig(
      searchConfigEntry,
      pillBadgeConfigEntry,
      pillBadgeLangKey
    ),
    productApiConfig: getParsedProductApiConfig(
      productApiConfigEntry,
      productAPIClientId,
      productApiWarehouseNumber
    ),
    translationsConfig: getTranslationsConfig(translationsEntry),
    lucidWorksApiConfig: getParsedLucidWorksApiConfig(
      lucidWorksApiConfigEntry
    ),
    productDetailApiConfig: getParsedProductDetailApiConfigParams(
      productDetailApiConfigEntry,
      locale
    ),
    productDetailApiV2Config: getParsedProductDetailApiConfigParams(
      productDetailApiV2ConfigEntry,
      locale
    )
  };
}
export {
  getProductTileConfigData
};
